import { Backspace, Search } from "@mui/icons-material";
import { Divider, IconButton, InputBase } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSearchConfig } from "../../context/SearchConfigProvider/useSearchConfig";
import { SearchType, WorkSpaceUserName } from "../../model/ItemModel";
import { GetItensFromWorkspaceIdSearchOnlyFolder, GetItensFromWorkspaceIdSearchOnlyRoot } from "../../services/Item/ItemServicesGet";
import { SearchFooter } from "./components/SearchFooter";
import { SearchboxFocus } from "./components/SearchboxFocus";
import { SearchboxSelect } from "./components/SearchboxSelect";
import { SearchboxWrapper } from "./components/SearchboxWrapper";
import _ from "lodash";
import { GetAllTags } from "../../services/TagService";
import { TagReturn } from "../../model/Tags";
import styles from "../navbar/Navbar.module.css";
import { KeyDrivePrimaryButton } from "../KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { KeyDriveBodyMin } from "../KeydriveComponents/Fonts/Body/KeyDriveBodyMin";

export type IListRenderRecent = {
    icon: string;
    text: string;
}

type ISearchbox = {
    setSearchboxFocus: (e: boolean) => void;
    searchboxFocus: boolean;
    placeholder?: string;
    idWorkspace: string;
}

type GenericCallerType = {
    nameOrg: string;
    skip: number;
    limit: number;
    search: string;
    contentSearch: string;
}


export const Searchbox: React.FC<ISearchbox> = ({
    placeholder,
    searchboxFocus,
    setSearchboxFocus,
    idWorkspace
}) => {

    const { t } = useTranslation();
    const [searshName, setSearshName] = useState<string>("");
    const [verifyTag, setVerifyTag] = useState<boolean>(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const { nameOrg } = useParams();
    const [selectedValue, setSelectedValue] = useState<string>("2");
    const [persistedCheckboxOnDismount, setPersistedCheckboxOnDismount] = useState<boolean>(false);
    const [isSearchBoxValid, setIsSearchBoxValid] = useState<boolean>(false);
    const [tagReturn, setTagReturn] = useState<TagReturn[]>([]);
	const liRef = useRef<HTMLLIElement | null>(null);
    const [searchType, setSearchType] = useState<SearchType>(SearchType.DEFAULT);
    const [dismissMenu, setDismissMenu] = useState<boolean>(false);

    useEffect(() => {
        if (!window.location.href.includes("wsallowed/")) {
            setIsSearchBoxValid(false);
            setSearshName("");
        } else {
            setIsSearchBoxValid(true);
        }
    }, [
        isSearchBoxValid,
        window.location.href
    ]);

    useEffect(() => {
        if (searshName == "") {
            resetAllParams();
        }
    }, [searshName]);

    useEffect(() => {
        const timer = setTimeout(() => {
            const newParams = new URLSearchParams(searchParams);

            if (searshName && searshName[0] !== "#") {
                if (searchType === SearchType.FOLDER) {
                    newParams.set("search", searshName);
                    newParams.set("folder", "true");
                    newParams.set("searchType", "folder");
                    newParams.set("bySearch", "true");
                } else if (searchType === SearchType.ONLYMYDOCUMENTS) {
                    newParams.set("search", searshName);
                    newParams.delete("folder");
                    newParams.set("searchType", "onlyDocuments");
                    newParams.set("bySearch", "true");
                } else if (searchType === SearchType.DEFAULT) {
                    newParams.set("search", searshName);
                    newParams.delete("folder");
                    newParams.set("searchType", "default");
                    newParams.set("bySearch", "true");
                }
            } else if (searshName && searshName[0] === "#") {
                newParams.delete("search");
                newParams.delete("searchType");
                newParams.delete("bySearch");

                if (searchType === SearchType.FOLDER) {
                    newParams.set("folder", "true");
                } else {
                    newParams.delete("folder");
                }
            } else if (searshName === "") {
                newParams.delete("search");
                newParams.delete("tag");
                newParams.delete("folder");
                newParams.delete("searchType");
                newParams.delete("bySearch");
            }

            setSearchParams(newParams);
        }, 1500);

        return () => clearTimeout(timer);
    }, [searshName]);

    useEffect(() => {
        if(idWorkspace != undefined)
        {
            if (searshName[0] == "#") {
                GetAllTags(idWorkspace,0,15,searshName.replace("#","%23"),[])
                .then((tags) =>{
                    setTagReturn(tags);
                })
            }
        }
    },[idWorkspace,searshName])

    function resetAllParams() {
        searchParams.delete("search")
        setSearchboxFocus(false);
        searchParams.delete("search");
        searchParams.delete("tag");
        searchParams.delete("folder");
        searchParams.delete("searchType");
        searchParams.delete("bySearch");
        setSearchParams(searchParams);
    }

    const onChangeName = (event: React.ChangeEvent<HTMLInputElement>) => {
       searchName(event.currentTarget.value);
       setDismissMenu(false);
    }

    function searchName(value: string) {
        if (value != undefined && value != "")
        {
            if (searchboxFocus == false)
            {
                setSearchboxFocus(true);
            }
            setSearshName(value);
        }
        else
        {
            setSearshName("");
        }
    }


    const selectedPlaceholderLabel = (): string => {
        if (nameOrg == undefined) return t("SearchBox.selectOrg");

        if (!isSearchBoxValid) return t("SearchBox.selectedWorkspace")

        return t("Navbar.placeholderImputText");
    }

    function onClickListTag(name:string, idTag:string){
        setSearshName(name)
        searchParams.set("tag", idTag);
        setVerifyTag(true);
        setDismissMenu(true);
    }


    return (
        <SearchboxWrapper>
                <IconButton sx={{ p: '10px 0 10px 10px' }} aria-label="menu" disabled={!isSearchBoxValid} onClick={() => setSearchboxFocus(true)}>
                    <Search />
                </IconButton>
                <InputBase
                    sx={{ ml: 1, flex: 1, fontSize: "14px" }}
                    placeholder={selectedPlaceholderLabel()}
                    inputProps={{ 'aria-label': 'search google maps' }}
                    onChange={onChangeName}
                    value={searshName}
                    onClick={e => setSearchboxFocus(true)}
                    disabled={!isSearchBoxValid}
                />
                { searshName[0] != "#" && !verifyTag && (
                    <SearchboxSelect 
                        selectedValue={selectedValue}
                        setSelectedValue={setSelectedValue}
                        setPersistedCheckboxOnDismount={setPersistedCheckboxOnDismount}
                        persistedCheckboxOnDismount={persistedCheckboxOnDismount}
                        setSearchType={setSearchType}
                        searchType={searchType}
                        setSearshName={setSearshName}
                    />
                ) }
                {searshName[0] == "#" && !dismissMenu && ( 
                    <div className={styles.DivTag}>
                        {tagReturn.map(tag => {
                            return (
                                <ul className={styles.UlListTag}>
                                    <li key={idWorkspace} className={styles.listTag} onClick={() => onClickListTag(tag?.name,tag?.id)} ref={liRef}>
                                        <div>
                                            {tag?.name}
                                        </div>
                                    </li>
                                </ul>
                            )
                        })}
                    </div>
                )}
        </SearchboxWrapper>
    )
}